export default "__VITE_ASSET__dae2a2a1__"